import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginComponent from "../Component/Login/LoginComp/Login";
import ForgotComp from "../Component/Login/Forgotpw/Forgot";
import ConfirmAccComp from "../Component/Login/ConfirmAccount/Confirmacc";
import SetpwComponent from "../Component/Login/Setnewpw/Setpw";
import CodeverifyComp from "../Component/Login/Codeverified/Codeverify";
import PasswordsuccessComp from "../Component/Login/Passwordsuccess/Pwsuccess";
import SignuponeComp from "../Component/SignupFlow/Signupone/Signupone";
import SignuptwoComp from "../Component/SignupFlow/Signuptwo/Signuptwo";
import CommunityComp from "../Component/Admin/Community/Community";
import Admin from "../Component/Admin/Admin";
import InProgress from "../Pages/InProgress/InProgress";
import AdminprofileComp from "../Component/Admin/Admin Profile/Adminprofile";
import ChangePassword from "../Component/changePassword/changepass";
import EmailVerificationComp from "../Component/SignupFlow/Email-verification/EmailVerify";
import EmailVerifiedComp from "../Component/SignupFlow/EmailVerified/EmailVerified";
import SignupSuccess from "../Component/SignupFlow/SignupSuccessful/Signupsuccess";
import LayoutComp from "../Layout/Layout";
import Chatboat from "../Component/Chatbot/Chatbot";
import PasswordChange from "../Component/Admin/PasswordChange/passwordChange";
import UpdateProvider from "../Component/UpdateUser/update-user"
import ProtectedRoute from "../Routes/protectedRoute";
import PrivacyPolicyPage from "../Pages/PrivacyPolicy/PrivacyPolicyPage";


const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>

                    {/* public Routes */}

       
        <Route path="/forgot-password" element={<ForgotComp />} />
        <Route path="/confirm-account-otp" element={<ConfirmAccComp />} />
        <Route path="/signupone" element={<SignuponeComp />} />
        <Route path="/signuptwo" element={<SignuptwoComp />} />
        <Route path="/email-verification" element={<EmailVerificationComp />} />
        <Route path="/email-verified" element={<EmailVerifiedComp />} />
        <Route path="/sign-up-success" element={<SignupSuccess />} />
        <Route path="/set-up-new-password" element={<SetpwComponent />} />
        <Route path="/code-verify" element={<CodeverifyComp />} />
        <Route path="/password-success" element={<PasswordsuccessComp />} />
        <Route path="/" element={<LoginComponent />} />
        <Route path="/Admin-community" element={<CommunityComp />} />
        <Route path="/inprogress" element={<InProgress />} />        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

                    {/* Admin routes */}

        <Route path="/user" element={<Admin />}>  
        {/* <Route path="/user" element={<ProtectedRoute><Admin /></ProtectedRoute>}> */}
          <Route path="update-user" element={<UpdateProvider/>}/>
          <Route path="inprogress" element={<InProgress />} />
          <Route path="user-profile" element={<AdminprofileComp />} />
          <Route path="chatboat"element={<Chatboat/>} />
          <Route path="change-password" element={<PasswordChange/>} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} /> 


        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
